<template>
  <div class="h-100">
    <div class="row">
      <div class="col-md-4 p-0">
        <h2 class="headline">Our Partner</h2>
        <p>lorem ipsum</p>
      </div>
      <div class="col-md-8">
        <div class="box"></div>
      </div>
      <!--<div class="marker timeline-trigger"></div>
        <div class="marker start-trigger"></div>
      <div class="marker end-trigger"></div>-->
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import $ from "jquery";
import { TimelineMax, TweenLite } from "gsap";

$(document).ready(function() {


  var triggerOffset = document.documentElement.clientHeight / 2;
  var sceneStart = 300;
  var duration = 400;

  var requestId = null;

  TweenLite.set(".box", {
    right: -100,
    top: -130
  });

  TweenLite.set(".timeline-trigger", {
    top: triggerOffset
  });

  TweenLite.set(".start-trigger", {
    top: sceneStart
  });

  TweenLite.set(".end-trigger", {
    top: sceneStart + duration
  });

  // SCROLL MAGIC!!!
  var tl = new TimelineMax({ paused: true })
    .to(".box", duration, { backgroundColor: "turquoise" }, sceneStart)
    .to(".box", duration, { scale: 1.8, x: -300, y: 200 }, sceneStart);
    

  // Only update on animation frames
  window.addEventListener("scroll", function() {
    if (!requestId) {
      requestId = requestAnimationFrame(update);
    }
  });

  update();

  // Set timeline time to scrollTop
  function update() {
    tl.time(window.pageYOffset + triggerOffset);
    requestId = null;
  }


    gsap.to("#rectangle-1", { duration: 2, x: 300, y: 100 });
});

export default {
  name: "AnimateComp",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.box {
  width: 400px;
  height: 100px;
  background: turquoise;
  overflow: hidden;
  position: absolute;
  top:-300px;
}
.box::before {
  position: absolute;
  content: '';
  width:100%;
  height: 100%;
  background: #42b983;

}
.fader {
    color: #fff;
}
.marker {
  width: 100%;
  left: 0;
  pointer-events: none;
  user-select: none;
  z-index: 100;
}

.timeline-trigger {
  position: fixed;
  border: 1px solid blue;
  z-index: 90;
}

.start-trigger {
  top: 200px;
  border: 1px solid green;
  position: absolute;
}

.end-trigger {
  border: 1px solid red;
  position: absolute;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#rectangle-1 {
  width: 400px;
  height: 200px;
  background: #42b983;
}
</style>
